import {
  getBlacklistInfoList,
  updateBlacklistInfo,
  addBlacklistInfo,
  deleteBlacklistInfo,
} from '../requests';

const initPagination = {
  pageSize: 10,
  currentPage: 1,
  total: 0,
};

const Model = {
  namespace: 'blackList',
  state: {
    tabledData: [],
    pagination: initPagination,
  },
  effects: {
    *getBlacklistInfoList({ payload }, { call, put }) {
      const res = yield call(getBlacklistInfoList, payload);
      if (res && res.code === 0) {
        yield put({
          type: 'saveBlacklistInfoList',
          payload: res.data,
        });
      }
    },
    *updateBlacklistInfo({ payload }, { call }) {
      return yield call(updateBlacklistInfo, payload);
    },
    *addBlacklistInfo({ payload }, { call }) {
      return yield call(addBlacklistInfo, payload);
    },
    *deleteBlacklistInfo({ payload }, { call }) {
      return yield call(deleteBlacklistInfo, payload);
    },
  },
  reducers: {
    saveBlacklistInfoList(state, { payload }) {
      const { pageNum, pageSize, total, dataInfos } = payload;
      const pagination = {
        currentPage: pageNum,
        pageSize,
        total,
      };
      return { ...state, tabledData: dataInfos, pagination };
    },
  },
};
export default Model;
